export enum SignInEvents {
    SignInFormModelDidUpdate = 'SignIn.FormModelDidUpdate',
}